import { render, staticRenderFns } from "./setLiving.vue?vue&type=template&id=8440a3e6&scoped=true&"
import script from "./setLiving.vue?vue&type=script&lang=js&"
export * from "./setLiving.vue?vue&type=script&lang=js&"
import style0 from "./setLiving.vue?vue&type=style&index=0&id=8440a3e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8440a3e6",
  null
  
)

export default component.exports